<template>
  <div class="discussion-wrap px-8">
    <div class="discussion-avatar">
      <AvatarComponent
        size="36"
        :url="profile ? profile.picture : null"
        :isMine="!profile"
      />
    </div>
    <div class="discussion-content" v-if="edit && token">
      <TiptapEditor
        v-model="content"
        name="content"
        hasMedia
        class="tiptap-custom"
        hideLabel
      />
      <div class="mt-4">
        <v-btn
          small
          @click="$emit('onCancel', entityId)"
          height="40"
          class="font-weight-bold elevation-0 text-none subtitle-1 mr-3 px-4"
          v-if="!hideCancel"
        >
          <translate>Cancel</translate>
        </v-btn>
        <v-btn
          small
          type="submit"
          color="primary"
          @click="onSubmit"
          height="40"
          class="font-weight-bold elevation-0 text-none subtitle-1 px-4"
        >
          <translate>Send</translate>
        </v-btn>
      </div>
    </div>
    <div class="discussion-content" v-else>
      <h5 class="video-thumb__title">
        <router-link
          :to="{ name: 'profilePerson', params: { key: profile.id } }"
        >
          {{ profile.name }}
        </router-link>
      </h5>
      <div v-if="createdDate" class="video-thumb__stat grey--text caption">
        {{ createdDate | ago }}
      </div>
      <span v-html="content"></span>
    </div>
  </div>
</template>
<script>
import TiptapEditor from "@/components/Tiptap/TiptapEditor";
import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Underline,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Image,
} from "tiptap-vuetify";
export default {
  props: {
    value: {},
    entityId: {},
    edit: { type: Boolean, default: false },
    profile: {
      type: Object,
      default: () => {},
    },
    modeEdit: { type: Boolean, default: false },
    hideCancel: { type: Boolean, default: false },
    createdDate: {},
  },
  components: {
    TiptapVuetify,
    TiptapEditor,
  },
  data() {
    return {
      extensions: [
        Link,
        Bold,
        Underline,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [3],
            },
          },
        ],
        Image,
      ],
      content: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.content = val;
      },
    },
  },
  methods: {
    async onSubmit() {
      if (!this.token) {
        const toggle = await this.$store.state.toggle.dialogConfirm.open(
          this.$gettext("Warning"),
          this.$gettext('You need to login'),
          { color: "warning" }
        );
        if (!toggle) return
        this.$router.push({name: 'login'})
      }

      if (this.content) {
        if (this.modeEdit) {
          let updated = await this.$store.dispatch("updateComment", {
            id: this.entityId,
            text: this.content,
          });
          this.$emit("onSubmit", updated[0] || updated);
        } else {
          let created = await this.$store.dispatch("newComment", {
            entityId: this.entityId,
            entityName: "post",
            parent: null,
            text: this.content,
          });
          if(created.error && created.error.message == 'friend blocked') {
            const result = await this.$store.state.toggle.dialogConfirm.open(
              this.$gettext("Could not comment !!!"),
              this.$gettext("This comment can not be created because this user blocked you"),
              { color: "warning" },
              true
            );
            return
          } else {
            this.$emit("onSubmit", created);
            this.content = "";
          }
        }
      }
    },
  },
};
</script>